import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@lightspeed/flame/Modal';

interface RowProps {
  isRowDisabled: boolean;
}

export const StyledModal = styled(Modal)`
  max-width: 50%;
  @media screen and (max-width: 992px) {
    max-width: 80%;
  }
`;

export const StyledModalHeader = styled(ModalHeader)`
  max-width: 100%;
  justify-content: space-between;
  > * {
    max-width: 90%;
  }
`;

export const StyledModalBody = styled(ModalBody)`
  padding: 0px !important;
  overflow: scroll;
  margin-bottom: -1px;
`;

export const StyledModalFooter = styled(ModalFooter)`
  z-index: 1;
`;

export const StyledButton = styled(Button)`
  > * {
    pointer-events: none;
  }
`;

export const StyledRow = styled(Flex)<RowProps>`
  opacity: ${(props) => (props.isRowDisabled ? '0.25' : 'inherit')};
`;

export const StyledItemDescription = styled(Box)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
